import { render, staticRenderFns } from "./CancelOrder.vue?vue&type=template&id=b41ab79c&scoped=true&"
import script from "./cancelOrder.js?vue&type=script&lang=js&"
export * from "./cancelOrder.js?vue&type=script&lang=js&"
import style0 from "./CancelOrder.vue?vue&type=style&index=0&id=b41ab79c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41ab79c",
  null
  
)

export default component.exports